<lg-dropdown
    className="lg-dropdown lg-dropdown--condensed lg-language-switch__dropdown"
    [matchWidth]="false"
    [condensed]="true"
    [definition]="_dropdownDef"
    [current]="_current"
    [hideSearch]="true"
    (currentChange)="_onCurrentChange($event)"
></lg-dropdown>
